import axios from "axios";
import { getToken, setToken } from "../utils/auth";
import useLoadingStore from "../store/loadingStore";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:80", // your actual API base URL
  baseURL: "https://api.motorvehicleslaw.in",
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach JWT token before every request
axiosInstance.interceptors.request.use(
  (config) => {
    const { setLoading } = useLoadingStore.getState();
    setLoading(true);

    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    const { setLoading } = useLoadingStore.getState();
    setLoading(false);
    return Promise.reject(error);
  }
);

// Save new token from response (if available)
axiosInstance.interceptors.response.use(
  (response) => {
    const { setLoading } = useLoadingStore.getState();
    setLoading(false);

    const newToken = response?.data?.token;
    if (newToken) {
      setToken(newToken);
    }
    return response;
  },
  (error) => {
    const { setLoading } = useLoadingStore.getState();
    setLoading(false);
    return Promise.reject(error);
  }
);

export default axiosInstance;
